// Console utilities for development vs production

/**
 * Development-only console logging
 */
export const devLog = {
  log: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(...args);
    }
  },
  info: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  },
  debug: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(...args);
    }
  }
};

/**
 * Remove all console.log statements from production builds
 * This is a no-op function that can replace console.log in production
 */
export const noop = (..._args: any[]) => {
  // Do nothing in production
};

/**
 * Conditional console wrapper
 */
export const conditionalConsole = process.env.NODE_ENV === 'development' ? console : {
  log: noop,
  warn: noop,
  error: console.error, // Keep errors in production
  info: noop,
  debug: noop
};